// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import type { JsonValueType } from '../inputTypeSchemas/JsonValueSchema';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { AdaptiveScanningBlockObservationSchema } from './AdaptiveScanningBlockObservationSchema';

/////////////////////////////////////////
// ADAPTIVE SCANNING BLOCK OBSERVATION RELATION SCHEMA
/////////////////////////////////////////

export type AdaptiveScanningBlockObservationRelations = {
  application: ApplicationWithRelations;
};

export type AdaptiveScanningBlockObservationWithRelations = Omit<z.infer<typeof AdaptiveScanningBlockObservationSchema>, "metadata"> & {
  metadata?: JsonValueType | null;
} & AdaptiveScanningBlockObservationRelations

export const AdaptiveScanningBlockObservationWithRelationsSchema: z.ZodType<AdaptiveScanningBlockObservationWithRelations> = AdaptiveScanningBlockObservationSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema),
}))